export default "__VITE_PUBLIC_ASSET__41637da5__"